import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor(
    public httpClient: HttpClient
  ) {
    this.httpClient.get('assets/Resources/ErrorMessage.json').subscribe(data => {
      this.errorDictionary = data;
    })
  }

  errorDictionary = undefined;
  // emailRegex = new RegExp();
  //emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
  emailRegex = new RegExp(/.+@.+/)
  emailformatRegex = new RegExp(/@/)
  //emailRegex = new RegExp(/(\\.[A - Za - z0 - 9 -] +)*/);
  emailspecialcharRegex = new RegExp(/@([a-zA-Z\-0-9\.]){1,}$/);
  emailpostionRegex = new RegExp(/@(([a-zA-Z\-0-9\.]{0,})+[a-zA-Z])$/);
 //emailfullformatRegex = new RegExp(/^ (.+)@(\S+) $/)*/

  validateEmail(arg) {
    if (this.emailRegex.test(arg)) {
      return true;
    } else {
      return false;
    }
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  validateRequiredField(arg) {
    if (arg == '' || arg == undefined) {
      return false;
    } else {
      return true;
    }
  }
  compareString(arg1: string, arg2: string) {
    if (arg1 === arg2) {
      return true;
    }
    else {
      return false;
    }
  }
  validateMinimunStringLength(arg, minlength) {
    if (arg.length < minlength) {
      return false;
    } else {
      return true;
    }
  }
  validateEmailformat(arg) {
    if (this.emailformatRegex.test(arg)) {
      return true;
    } else {
      return false;
    }
  }
  validateEmailfullformat(arg) {
    if (this.emailRegex.test(arg)) {
      return true;
    } else {
      return false;
    }
  }
  validateEmailspecialCharformat(arg) {
    return this.emailspecialcharRegex.test(arg);
  }
  validatemailpostionRegexformat(arg) {
    return this.emailpostionRegex.test(arg);
  }
  getErrorMessage(type, arg, arg2) {
    switch (type) {
      case "required": {
        return this.errorDictionary.required.replace('#placeholder#', arg)
      }
      case "valid": {
        return this.errorDictionary.valid.replace("#placeholder#", arg)
      }
      case "mailvalidateformat": {
        let tempresult = this.errorDictionary.mailvalidateformat.replace("#placeholder#", arg)
        return tempresult.replace("#placeholder#", arg2)
      }
      case "mailvalidatefullformat": {

        return this.errorDictionary.mailvalidatefullformat.replace("#placeholder#", arg)
      }
      case "mailspecialChar": {
        var index = arg.indexOf("@");
        const words = arg.substr(index + 1);
        var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        var args = words.match(format)
        return this.errorDictionary.mailspecialformat.replace("#placeholder#", args[0])
      }
      case "mailpositionChar": {

        return this.errorDictionary.emailpostionRegex.replace("#placeholder#", arg)
      }

      case "minLength": {
        let tempResult = this.errorDictionary.minLength.replace("#placeholder#", arg)
        return tempResult.replace("#placeholder#", arg2)
      }

    }
  }
}
